import { VerticalArticlesClient } from './VerticalArticlesClient';
import { usePageDataContext } from '$/(cms)/_modules/cmsService/pageDataService/pageDataProvider';
import { ComponentVerticalArticles } from '$/(cms)/_modules/cmsService/types';

export const VerticalArticles: React.FC<ComponentVerticalArticles> = (
  props,
) => {
  const { pageData } = usePageDataContext();
  const articlesResp = pageData.verticalArticlesData?.find(
    (d) => d.componentId === props.id,
  )?.data;

  return (
    <VerticalArticlesClient
      {...props}
      initialArticles={articlesResp?.data ?? []}
    />
  );
};
